var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navlist"}},[_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.id,on:{"click":function($event){return _vm.$emit('nav', item)}}},[_c('a',[_vm._v(_vm._s(_vm.no_dash(item)))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }